import i18n, { type TFunction } from 'i18next'
import { initReactI18next } from 'react-i18next'

import { namespaces } from '@/infra/i18n/locales'
import { resources } from '@/infra/i18n/resources'
import { storageKeys } from '@/utils/constants'

export type TLocalidade = 'pt-BR' | 'es-CL'

export const defaultNS = 'common'

function localidadePersistida(): TLocalidade | null {
  try {
    const usuarioSerializado = globalThis.localStorage.getItem(storageKeys.user)
    return usuarioSerializado ? (JSON.parse(usuarioSerializado)?.localidade ?? null) : null
  } catch {
    return null
  }
}

export function setLocalidade(locale?: TLocalidade | null): Promise<TFunction> {
  return i18n.changeLanguage(locale ?? navigator.language)
}

i18n.use(initReactI18next).init({
  lng: localidadePersistida() ?? navigator.language,
  supportedLngs: ['pt-BR', 'es-CL'],
  fallbackLng: {
    es: ['es-CL'],
    pt: ['pt-BR'],
    default: ['pt-BR'],
  },
  ns: namespaces,
  defaultNS,
  resources,
  interpolation: { escapeValue: false },
})

export { default } from 'i18next'
